import "../style/entityExtractionFromDesc.scss";
import Title from "./common/Title";
import searchIcon from "../common/images/search_icon.png";
import { dataLoader } from "@unbxd-ui/unbxd-react-components";
import utils from "../common/utils";
import { useEffect, useState } from "react";
export default function EntityExtractionFromDesc() {
  const [apiError, setApiError] = useState(false);

  const queriesMap = [
    "black solid woven regular top, has a round neck, long sleeves, an attached lining Improve your personal style with a brand new long sleeve top designed by IMARA. When you want to have the perfect outfit for a fun lunch with the girls, you'll want to put this black piece with an strap boot and slim fit pants.",
    "black and rust orange floral print woven tiered midi fit and flare dress with ruffles, has a high neck, short ruched sleeves, elasticated waistband, an attached lining, and flared hem",
    "navy peach coloured printed woven midi line dress has round neck short cold shoulder sleeve hook eye closure flared hem maintain trendy style all year long stunning dress from raga semi formal brunch look pair printed piece high heel cute clutch",
    "Gorgeous woman's full length coat that keeps the cold out. It is classy, stylish and perfect for every day, going to the office or a night out. Made of cashmere with big buttons for easy closure. This coat comes in Navy and keeps you warm and snuggly when you are on the go. Has two outer pockets and one interior deep pockets with easy access to your wallet or mobile phone"
  ];
  const [query, setQuery] = useState(queriesMap[0]);
  const [results, setResults] = useState({});
  const [selectedTag, setSelectedTag] = useState(queriesMap[0]);
  const [searchVal, setSearchVal] = useState(queriesMap[0]);
  const [secondaryT, setSecondaryT] = useState([]);
  const [primaryT, setPrimaryT] = useState([]);
  const [ isLoading, setIsLoading ] = useState(false);

  const callApi2 = () => {
    setIsLoading(true);
    const def = dataLoader.getRequestDef({
      requestId: "getDescriptionBaseDoc",
      params: {
        text: query,
      },
    });

    def.done((response = {}) => {
      let { errors = [] } = response;
      setApiError(false);
      setIsLoading(false);

      if (errors && errors.length) {
        console.log(errors[0]);
      }
    });

    def.catch((error) => {
      setIsLoading(true);
      setApiError(true);
      console.log("46----------", error);
    });
    return def;
  };

  const highlight = function (text, type = "primary") {
    var inputText = document.getElementById("queryDesc");
    var innerHTML = inputText?.innerHTML;
    var index = innerHTML?.toLowerCase().indexOf(text.toLowerCase());
    if (index >= 0) {
      innerHTML =
        innerHTML.substring(0, index) +
        `<span class='highlight-${type}'>` +
        innerHTML.substring(index, index + text.length) +
        "</span>" +
        innerHTML.substring(index + text.length);
      inputText.innerHTML = innerHTML;
    }
  };

  useEffect(() => {
    if (query) {
      const api = callApi2();
      api.then((response = []) => {
        const { data = {} } = response?.data;
        const { tags = [] } = data;
        const primary = {};
        const secondary = {};
        const primaryTags = [];
        const secondaryTags = [];
        Object.keys(tags).forEach((tag) => {
          if (tag.includes("_")) {
            secondary[tag.replace('S_', '')] = tags[tag].join(" , ");
            secondaryTags.push(tags[tag]);
          } else {
            primary[tag] = tags[tag].join(" , ");
            primaryTags.push(tags[tag]);
          }
        });

        setSecondaryT(secondaryTags.flat());
        setPrimaryT(primaryTags.flat());

        setResults({ primary: primary, secondary: secondary });
      });
    }
  }, [query]);

  useEffect(() => {
    for (let i = 0; i < secondaryT.length; i++) {
      highlight(secondaryT[i], "secondary");
    }
  }, [secondaryT]);

  useEffect(() => {
    for (let i = 0; i < primaryT.length; i++) {
      highlight(primaryT[i], "primary");
    }
  }, [primaryT]);

  const onSampleQueryClick = (e) => {
    if (e.length > 0) {
      setQuery(e);
      setSelectedTag(e);
      setSearchVal(e);
    } else {
      setApiError(true);
    }

    //onSearchClick(null, val);
  };


  function debounce(func, timeout = 1000) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }
  const saveData = debounce(function (e) {
    onSampleQueryClick(e.target.value);
  });

  return (
    <div className="columns highlight-info sticky-hexagon">
      <div className="column col-xl-12 col-6 last-xl">
        <div className="content-wrap">
        {isLoading && <img className="loading-icon" src={"/images/blueLoader.svg"} /> }
          {!isLoading && (
            <div>
              <div className="entry-box ner-results-table text-center">
                <div className="demo-table-header columns">
                  <div className="column">Product Description</div>
                </div>
                <div className="demo-table-data columns">
                  <div id="queryDesc" className="column p-4">
                    {query}
                  </div>
                </div>
              </div>

              {results["primary"] && !apiError && Object.keys(results["primary"]).length ? (
                <>
                  <div className="attribute-heading">Primary Attributes</div>

                  <div className=" des-table ner-results-table text-center">
                    <div className="demo-table-header columns">
                      <div className="column">{`Entities`}</div>
                      <div className="column">{`Values`}</div>
                    </div>
                    <div>
                      {Object.keys(results["primary"]).map((item) => {
                        return (
                          <div className="demo-table-data columns">
                            <div className="column">
                              {utils.capitalize(item.toLowerCase())}
                            </div>
                            <div className="column">
                              {results["primary"][item]}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

              {results["secondary"] && !apiError &&
              Object.keys(results["secondary"]).length ? (
                <>
                  <div className="attribute-heading">Secondary Attributes</div>
                  <div className="des-table ner-results-table text-center">
                    <div className="demo-table-header columns">
                      <div className="column">{`Entities`}</div>
                      <div className="column">{`Values`}</div>
                    </div>
                    <div>
                      {Object.keys(results["secondary"]).map((item) => {
                        return (
                          <div className="demo-table-data columns">
                            <div className="column">
                              {utils.capitalize(item.toLowerCase())}
                            </div>
                            <div className="column">
                              {results["secondary"][item]}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}

            
            </div>
          )}
        </div>
      </div>

      <div className="column col-xl-12 col-6 highlight-content-right first-xl">
        <div className="content-wrap">
          <Title
            title="Description Based Document Enrichment"
            className="mb-2 sub-title title"
          />
        </div>

        <div className="feature-description desc col-xl-12 col-12">
          Extraction of entities based on unstructured data like description.
          The entities can be used for generating and differentiating between
          Primary Attributes and secondary attributes.
        </div>
        <div className="spin">Try Your Query</div>

        <div className="vertical-dd-container">
          {/* <textarea
            rows={5}
            className="vertical-dd-input"
            placeholder="Enter the Product Description"
            onChange={(e)=>debounce(onSampleQueryClick(e.target.value))}
            value={query}
            
          /> */}
          <div className="search-container">
            <div className="search-input-container">
              <input
                type="text"
                value={searchVal}
                className="search-input"
                onChange={(e) => setSearchVal(e.target.value)}
              />
              <img src={searchIcon} className="search-img" />
            </div>
            <button
              onClick={() => onSampleQueryClick(searchVal)}
              className="search-button"
            >
              Search
            </button>
          </div>
          {apiError && (
            <div class="des-api-error entity-extraction">
              Something went wrong. Please check again with a valid query.
            </div>
          )}
          <div className="spin">Try Sample Queries</div>
          <div className="sample-queries-container">
            {queriesMap.map((item) => {
              return (
                <span
                  className={`sample-queries-tags sample-queries-tags-desc ${
                    selectedTag === item ? "sample-query-highlight" : ""
                  }`}
                  title={item}
                  onClick={onSampleQueryClick.bind(null, item)}
                >
                  {item}{" "}
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
